import Token from 'common/models/MyToken';
import React from 'react';
import ChainScanTokenLink from '../ChainScanTokenLink/ChainScanTokenLink';

type Props = {
  token: Token | null | undefined;
};

const FormatTokenName: React.FC<Props> = (props) => {
  if (props.token != null) {
    return (
      <div className="flex items-baseline">
        {props.token.name}
        <ChainScanTokenLink token={props.token} />
      </div>
    );
  }

  return null;
};

export default FormatTokenName;
